(() => {
  const initGorgiasChatPromise = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise((resolve) => {
        window.addEventListener('gorgias-widget-loaded', resolve, { once: true });
      });

  const minimizeGorgiasChat = () => {
    if (!window.GorgiasChat) return;

    if (typeof window.GorgiasChat.close === 'function') {
      window.GorgiasChat.close();
      return;
    }

    if (typeof window.GorgiasChat.minimize === 'function') {
      window.GorgiasChat.minimize();
    }
  };

  const openCartDrawer = () => {
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        minimizeGorgiasChat();
        cartDrawer.open();
        return true;
      }
    } catch (_) {
      // cart-drawer.open can throw in edge cases — fall through to header cart trigger
    }

    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon) {
      minimizeGorgiasChat();
      cartIcon.click();
      return true;
    }

    return false;
  };

  const getCartLinkSelectors = () => {
    const fallback = ['a[href="/cart"]', 'a[href^="/cart?"]'];
    if (typeof window.routes === 'undefined' || !window.routes.cart_url) {
      return fallback;
    }
    try {
      const path = new URL(window.routes.cart_url, window.location.origin).pathname;
      return [`a[href="${path}"]`, `a[href^="${path}?"]`];
    } catch (_) {
      // malformed routes.cart_url — use plain /cart selectors
      return fallback;
    }
  };

  const bindCartOverrideInDocument = (scopeDocument) => {
    if (!scopeDocument) return;

    const selectors = [
      '#header-view-cart-button',
      '[data-testid="shopping-cart-cta"]',
      'button[aria-label="View cart"]',
      ...getCartLinkSelectors(),
    ];

    scopeDocument.querySelectorAll(selectors.join(',')).forEach((cta) => {
      if (cta.dataset.gorgiasCartOverrideBound === 'true') return;
      cta.dataset.gorgiasCartOverrideBound = 'true';

      const overrideClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        openCartDrawer();
      };

      cta.addEventListener('click', overrideClick, true);
    });
  };

  const bindCartOverride = () => {
    bindCartOverrideInDocument(document);

    document.querySelectorAll('iframe').forEach((iframe) => {
      try {
        if (iframe.contentDocument) {
          bindCartOverrideInDocument(iframe.contentDocument);
        }
      } catch (_) {
        // cross-origin iframe — skip (cannot access contentDocument)
      }
    });
  };

  initGorgiasChatPromise.then(() => {
    bindCartOverride();

    let rafId = null;
    const observer = new MutationObserver(() => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        bindCartOverride();
        rafId = null;
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener(
      'pagehide',
      () => {
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
        observer.disconnect();
        if (window.GorgiasChat && typeof window.GorgiasChat.off === 'function') {
          window.GorgiasChat.off('ready', bindCartOverride);
          window.GorgiasChat.off('widget:opened', bindCartOverride);
        }
      },
      { once: true }
    );

    if (window.GorgiasChat && typeof window.GorgiasChat.on === 'function') {
      window.GorgiasChat.on('ready', bindCartOverride);
      window.GorgiasChat.on('widget:opened', bindCartOverride);
    }
  });
})();
